import { useEffect, useState } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import PageContainer from "../../Components/Page/PageContainer";
import { TabMenu } from "primereact/tabmenu";
import { Card } from "primereact/card";
import { ROUTES } from "../../config/routes";

const TAB_PATHS = [
  ROUTES.CLASSIFIERS_MUSIC_CLASSIFIER,
  ROUTES.CLASSIFIERS_MUSIC_CLASSIFIER_HISTORY,
  ROUTES.CLASSIFIERS_VIDEO_AUDITOR,
  ROUTES.CLASSIFIERS_BULK,
];

const Classifiers = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const path = location.pathname;
    const idx = TAB_PATHS.findIndex((p) => path === p || path.startsWith(p + "/"));
    setActiveIndex(idx >= 0 ? idx : 0);
  }, [location.pathname]);

  const handleTabChange = (e: { index: number }) => {
    setActiveIndex(e.index);
    navigate(TAB_PATHS[e.index]);
  };

  const items = [
    { label: "Music Classifier", icon: "pi pi-volume-up" },
    { label: "Music Classifier History", icon: "pi pi-history" },
    { label: "Video Auditor", icon: "pi pi-video" },
    { label: "Bulk Analysis", icon: "pi pi-list" },
  ];

  return (
    <PageContainer
      HomeMenuBarprops={{
        title: (
          <span
            style={{ cursor: "pointer", fontWeight: "bold" }}
            onClick={() => navigate(ROUTES.CLASSIFIERS)}
          >
            Classifiers
          </span>
        ),
        Tabs: (
          <TabMenu
            activeIndex={activeIndex}
            onTabChange={handleTabChange}
            model={items}
          />
        ),
      }}
    >
      <div style={{ width: "96%", margin: "0 auto" }}>
        <Card unstyled style={{ marginTop: "2rem", boxShadow: "none" }}>
          <Outlet />
        </Card>
      </div>
    </PageContainer>
  );
};

export default Classifiers;
